/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiUserUserType
 */
export interface ApiUserUserType {
    /**
     * 
     * @type {string}
     * @memberof ApiUserUserType
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiUserUserType
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiUserUserType
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiUserUserType
     */
    description?: string;
}

/**
 * Check if a given object implements the ApiUserUserType interface.
 */
export function instanceOfApiUserUserType(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApiUserUserTypeFromJSON(json: any): ApiUserUserType {
    return ApiUserUserTypeFromJSONTyped(json, false);
}

export function ApiUserUserTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiUserUserType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function ApiUserUserTypeToJSON(value?: ApiUserUserType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'type': value.type,
        'description': value.description,
    };
}

